import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { ContractStatus } from '@/modules/Contract/types'
import { useCustomerContracts } from '@/modules/Customer/hooks/use-customer-contracts'

const Contracts = () => {
    const {
        contracts,
        pagination,
        stateComponent,
        isFetching,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        selectionActions,
        filterItems,
        selectedContracts,
        handleSelectionChange,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useCustomerContracts()

    return (
        <div className="space-y-2">
            {/* Data Table */}
            <Paper data-tour="contracts-list">
                <FilterBar
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                    hideSearch
                />
                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={contracts}
                        rowKey={(row) => String(row?.contract_id)}
                        size="small"
                        resizable
                        loading={!contracts.length && !pagination}
                        isFetching={isFetching}
                        emptyMessage={t('no-contracts', {
                            defaultValue: 'Không có hợp đồng nào',
                        })}
                        selection={{
                            selectedKeys: selectedContracts,
                            onSelectionChange: handleSelectionChange,
                            getRowKey: (row) => String(row?.contract_id),
                            actions: selectionActions,
                            canSelect(row) {
                                return (
                                    ContractStatus.Active !==
                                    row?.contract_status
                                )
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={
                            pagination
                                ? {
                                      page: params.page || 1,
                                      pageSize: params.page_size || 10,
                                      total: pagination.total || 0,
                                      onPageChange: handlePageChange,
                                      onPageSizeChange: handlePageSizeChange,
                                      pageSizeOptions: [10, 20, 50, 100],
                                  }
                                : undefined
                        }
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('search-contract', {
                                    defaultValue: 'Tìm kiếm hợp đồng...',
                                }),
                                tourId: 'contract-search',
                            },
                            settings: {
                                show: true,
                                storageKey: 'customer-contracts',
                            },
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default Contracts
